import React from 'react';
import { Box, FloatingContainer, Screen } from '~/commonComponents';
import { FeaturesSection, HeaderSection, ProcessStepsSection } from './components';

export const HowItWorksScreen: React.FC = () => {
  return (
    <Screen>
      <FloatingContainer borderRadius={0} flex={1} margin={16} minWidth="auto">
        <Box position="relative">
          <HeaderSection />
          <FeaturesSection />
          <ProcessStepsSection />
        </Box>
      </FloatingContainer>
    </Screen>
  );
};
